/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export const contactColumns = [
  {
    label: "Main",
    value: "Main",
  },
  {
    label: "Contact Type",
    value: "Contact Type",
  },
  {
    label: "Description",
    value: "Description",
  },
  {
    label: "Street",
    value: "Street",
  },
  {
    label: "Number",
    value: "Number",
  },
  {
    label: "City",
    value: "City",
  },
  {
    label: "Country",
    value: "Country",
  },
  {
    label: "Country \nSub-Division",
    value: "Country \nSub-Division",
  },
  {
    label: "ACTION",
    value: "ACTION",
    right: true
  },
];

export const accountColumns = [
  {
    label: "Bank",
    value: "bank",
  },
  {
    label: "Currency",
    value: "accountCurrency",
  },
  {
    label: "Name",
    value: "accountName",
  },
  {
    label: "Sort Code",
    value: "bankSortCode",
  },
  {
    label: "Swift",
    value: "bankSwiftBIC",
  },
  {
    label: "Acc. Number",
    value: "accountNumber",
  },
  {
    label: "IBAN",
    value: "bankIBAN",
  },
  {
    label: "Corresp. Bank",
    value: "correspbank",
  },
  {
    label: "ACH Routing Number",
    value: "routingNumber",
  },
  {
    label: "Transit/ABA Number (NY)",
    value: "transitAbaNumber",
  },
  {
    label: "Corresp. BIC",
    value: "correspbank_BIC",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const relationshipColumns = [
  {
    label: "Insurer",
    value: "insurer",
  },
  {
    label: "Capacity Exposure",
    value: "capacity",
  },
  {
    label: "NDA",
    value: "nda",
  },
  {
    label: "NDA Expiration Date",
    value: "expirationDate",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const relationshipColumnsSelect = [
  {
    label: "",
    value: "",
  },
  {
    label: "Insurer",
    value: "insurer",
    maxWidth:'50%'
  },
  {
    label: "Capacity Exposure",
    value: "capacity",
  },
  {
    label: "NDA",
    value: "nda",
  },
  {
    label: "NDA Expiration Date",
    value: "expirationDate",
  },
];

export const clientSupplierColumns = [
  {
    label: "Supplier",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const employeeColumns = [
  {
    label: "Contact Department",
  },
  {
    label: "Job Title",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const accessGroupColumns = [
  {
    label: "Client",
  },
  {
    label: "Access Group",
  },
  {
    label: "ACTION",
    right: true 
  },
]

export const insurerColumns = [
  {
    label: "Insurer Legal Entity",
  },
  {
    label: "MAS",
  },
  {
    label: "Lirma Type",
  },
  {
    label: "Lloyds Type",
  },
  {
    label: "Lloyds Syndicate Code",
  },
  {
    label: "ACTION",
    right: true
  },
]

export const insurerColumnsRunOff = [
  {
    label: "Insurer Legal Entity",
  },
  {
    label: "Run-Off",
  },
  {
    label: "",
  },
  {
    label: "",
  },
  {
    label: "",
  },
  {
    label: "",
    right: true
  },
]


export const texelBranchColumns = [
  {
    label: "Texel Legal Entity",
  },
  {
    label: "Legal Entity Register Number",
  },
  {
    label: "Legal Entity VAT Number",
  },
  {
    label: "ACTION",
    right: true
  },
]

export const surplusColumn = [
  {
    label: "Surplus Broker",
    value: "surplusBroker",
  },
  {
    label: "Contract Status",
    value: "contractStatus",
  },
  {
    label: "Contract Expiry Date",
    value: "contractExpiryDate",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const thirdPartyColumns = [
  {
    label: "3rd Party",
    value: "thirdParty",
  },
  {
    label: "Contract Status",
    value: "contractStatus",
  },
  {
    label: "Contract Expiry Date",
    value: "contractExpiryDate",
  },
  {
    label: "ACTION",
    right: true
  },
];

export const governmentStatesColumns = [
  {
    label: "Fee Type",
    value: "feetype",
  },
  {
    label: "Tax Type",
    value: "taxType",
  },
  {
    label: "Rate & Basis",
    value: "rateBasis",
  },
  {
    label: "Charge Type",
    value: "chargeType",
  },
  {
    label: "Fee Value",
    value: "feeValue",
  },
  {
    label: "Notes",
    value: "note",
  },
  {
    label: "ACTION",
    right: true
  },
];